import Crud from '../views/ModeloMensagem/Crud'
import Entity from '../views/ModeloMensagem/Add'

let routes = {
    path: '/modelos_mensagem',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/modelos_mensagem/add',
            name: 'NewModeloMensagem',
            component: Entity
        },
        {
            path: '/modelos_mensagem/edit/:id?',
            name: 'EditModeloMensagem',
            component: Entity
        },
        {
            path: '/modelos_mensagem',
            name: 'list-modelos_mensagem',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Modelos de Mensagem',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
